import ReactDOM from 'react-dom/client';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter
        basename="/">
        <App />
    </BrowserRouter>
);
const appDetails = {
    buildVersion: window._env_.VITE_BUILD_VERSION,
    buildCommit: window._env_.VITE_BUILD_COMMIT,
    builtAt: window._env_.VITE_BUILT_AT,
    builtBy: window._env_.VITE_BUILT_BY,
    builtOn: window._env_.VITE_BUILT_ON,
    buildBranch: window._env_.VITE_BUILD_BRANCH,
};
console.table(appDetails);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();